import Styled from "styled-components"; 

export const Container = Styled.div`
display: flex;
align-items: center;
flex-direction: row;


`;
export const Input = Styled.input`

min-width: 15px;
min-height: 15px;

`;

export const Label = Styled.label`
margin-left: 5px;
font-size: ${props => props.theme.fontSize.small};
`;